export default __webpack_public_path__ + "static/article-how-do-caravans-and-campervans-compare-9bd530d5c5d144125e6516d0b4a19687.jpg";